import React, {Component} from 'react'
import ReactPlayer from 'react-player/lazy';
import {LevelApi} from 'services/network/api';

class Player extends Component {
    state = {
        file: undefined,
        pip: false,
        playing: false,
        light: false,
        volume: 0.8,
        muted: false,
        played: 0,
        loaded: 0,
        duration: 0,
        playbackRate: 1.0,
        loop: false
    };


    componentDidMount() {
        //this.load();
    }

    load() {
        const {url} = this.props;

        if (url) {
            LevelApi.GetMedia(url)
                .then(res => {
                    if (res && res.status == 200)
                        this.setState({file: [res.data]})
                });
        }
    }

    handlePlay = () => {
        console.log('onPlay');
        this.setState({playing: true})
    };

    handleEnablePIP = () => {
        console.log('onEnablePIP');
        this.setState({pip: true})
    };

    handleDisablePIP = () => {
        console.log('onDisablePIP');
        this.setState({pip: false})
    };

    handlePause = () => {
        console.log('onPause');
        this.setState({playing: false})
    };

    handleProgress = state => {
        console.log('onProgress', state);
        // We only want to update time slider if we are not currently seeking
        if (!this.state.seeking) {
            this.setState(state)
        }
    };

    handleEnded = () => {
        console.log('onEnded');
        this.setState({playing: this.state.loop})
    };

    handleDuration = (duration) => {
        console.log('onDuration', duration);
        this.setState({duration})
    };

    ref = player => {
        this.player = player
    };

    render() {
        const {url} = this.props;
        const {playing, light, volume, muted, loop, played, loaded, duration, playbackRate, pip, file} = this.state;

        if (!url)
            return (<div>Loading</div>);

        return (
            <div className='app'>
                <ReactPlayer
                    ref={this.ref}
                    className='react-player'
                    width='100%'
                    height='100%'
                    url={url}
                    pip={pip}
                    controls
                    light={light}
                    loop={loop}
                    playbackRate={playbackRate}
                    volume={volume}
                    onReady={() => console.log('onReady')}
                    onStart={() => console.log('onStart')}
                    onPlay={this.handlePlay}
                    onEnablePIP={this.handleEnablePIP}
                    onDisablePIP={this.handleDisablePIP}
                    onPause={this.handlePause}
                    onBuffer={() => console.log('onBuffer')}
                    onSeek={e => console.log('onSeek', e)}
                    onEnded={this.handleEnded}
                    onError={e => console.log('onError', e)}
                    onProgress={this.handleProgress}
                    onDuration={this.handleDuration}
                    onContextMenu={e => e.preventDefault()}
                    muted={false}
                    playing={false}
                    config={{
                        file: {
                            attributes: {
                                //preload: 'none',
                                controlsList: 'nodownload',
                                disablePictureInPicture: true
                            },
                        }
                    }}
                />
            </div>
        )
    }
}

export default Player;